var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterWtsapp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 245.538,
    height: 198,
    viewBox: "0 0 245.538 198",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#abbcce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#cfd9e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#ebeff3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#f6f8fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#e2e8ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#afbfd0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#a5b7ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#aabbcd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#b9c7d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#d2dbe4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4f7f9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.628,
    y1: 1.128,
    x2: 1.628,
    y2: 1.128,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.372,
    y1: -0.128,
    x2: -0.628,
    y2: -0.128,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(-1625 -785)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    transform: "translate(1808.253 802.906) rotate(38)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(1.041 0.497)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M144.217,27.715V39.147a2.178,2.178,0,0,1-2.178,2.179H91.958a2.178,2.178,0,0,1-2.178-2.179V28.222C89.78,13.126,102.129.375,117.225.5a27.218,27.218,0,0,1,26.989,27.217Z",
    transform: "translate(-67.063 -0.497)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(28.159 5.443)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M119.257,52.008a7.586,7.586,0,0,1-7.577-7.577A21.862,21.862,0,0,1,133.309,22.39c.3,0,.614.008.919.02a21.619,21.619,0,0,1,20.679,21.6v.428a7.586,7.586,0,0,1-7.577,7.577H119.257Z",
    transform: "translate(-111.516 -22.229)",
    fill: "#4b4495"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M132.833,21.76v.32c.3,0,.609.008.911.02A21.457,21.457,0,0,1,154.27,43.535v.428a7.427,7.427,0,0,1-7.419,7.419H118.779a7.427,7.427,0,0,1-7.419-7.419A21.7,21.7,0,0,1,132.83,22.08v-.32m0,0a22.028,22.028,0,0,0-21.79,22.2h0a7.739,7.739,0,0,0,7.739,7.739h28.072a7.739,7.739,0,0,0,7.739-7.739v-.428a21.776,21.776,0,0,0-20.83-21.754c-.31-.013-.619-.02-.927-.02h0Z",
    transform: "translate(-111.04 -21.76)",
    fill: "#cbd5e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(8.166 9.961)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M216.422,64.482h-1.416a1.2,1.2,0,0,1-1.2-1.2V61.868a1.2,1.2,0,0,0-1.2-1.2h-.87a1.2,1.2,0,0,0-1.2,1.2v1.416a1.2,1.2,0,0,1-1.2,1.2h-1.416a1.2,1.2,0,0,0-1.2,1.2v.87a1.2,1.2,0,0,0,1.2,1.2h1.416a1.2,1.2,0,0,1,1.2,1.2v1.416a1.2,1.2,0,0,0,1.2,1.2h.87a1.2,1.2,0,0,0,1.2-1.2V68.946a1.2,1.2,0,0,1,1.2-1.2h1.416a1.2,1.2,0,0,0,1.2-1.2v-.87A1.2,1.2,0,0,0,216.422,64.482Z",
    transform: "translate(-190.4 -60.67)",
    fill: "#6ae3fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M148.82,60.68h-.87a1.2,1.2,0,0,0-1.2,1.2v1.416a1.2,1.2,0,0,1-1.2,1.2h-1.416a1.2,1.2,0,0,0-1.2,1.2v.87a1.2,1.2,0,0,0,1.2,1.2h1.416a1.2,1.2,0,0,1,1.2,1.2v1.416a1.2,1.2,0,0,0,1.2,1.2h.87a1.2,1.2,0,0,0,1.2-1.2V68.956a1.2,1.2,0,0,1,1.2-1.2h1.416a1.2,1.2,0,0,0,1.2-1.2v-.87a1.2,1.2,0,0,0-1.2-1.2h-1.416a1.2,1.2,0,0,1-1.2-1.2V61.878A1.2,1.2,0,0,0,148.82,60.68Z",
    transform: "translate(-142.94 -60.677)",
    fill: "#6ae3fc"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M304.845,108.077c2.219-.983,5.261,2.056,4.278,4.278a48.343,48.343,0,0,1-23.5,23.5c-2.222.983-5.263-2.058-4.278-4.28a48.38,48.38,0,0,1,23.5-23.5Z",
    transform: "translate(-209.447 -80.396)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M285.622,135.857c-2.219.983-5.261-2.056-4.278-4.278a48.343,48.343,0,0,1,23.5-23.5c2.222-.983,5.263,2.058,4.278,4.28a48.38,48.38,0,0,1-23.5,23.5Z",
    transform: "translate(-281.154 -62.22)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M142.046,168.49a2.178,2.178,0,0,1,2.178,2.179v22.317a27.217,27.217,0,0,1-54.434,0V170.669a2.178,2.178,0,0,1,2.179-2.179h50.08Z",
    transform: "translate(-67.071 -125.485)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(36.21 43.005)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M142.49,168.49h27.217v3.195a5.122,5.122,0,0,1-5.12,5.12H147.61a5.122,5.122,0,0,1-5.12-5.12V168.49Z",
    transform: "translate(-142.49 -168.49)",
    fill: "#4b4495"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19956",
    transform: "translate(3.271 1.608)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_33",
    transform: "translate(0 0.451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M157.652,178.614a4.2,4.2,0,0,0-.783-.261,2.09,2.09,0,0,1-.645-.241.415.415,0,0,1-.189-.369.527.527,0,0,1,.215-.448.961.961,0,0,1,.584-.161,1.345,1.345,0,0,1,.512.085,1.755,1.755,0,0,1,.43.261.7.7,0,0,0,.123.064.275.275,0,0,0,.1.018.19.19,0,0,0,.159-.09.334.334,0,0,0,.067-.212.37.37,0,0,0-.031-.156.433.433,0,0,0-.1-.125,1.8,1.8,0,0,0-1.262-.443,1.729,1.729,0,0,0-.76.161,1.245,1.245,0,0,0-.527.448,1.149,1.149,0,0,0-.189.65,1.022,1.022,0,0,0,.151.579,1.1,1.1,0,0,0,.451.374,3.579,3.579,0,0,0,.776.256,2.482,2.482,0,0,1,.658.23.373.373,0,0,1,.2.343.5.5,0,0,1-.212.435,1.05,1.05,0,0,1-.607.148,1.9,1.9,0,0,1-.563-.082,1.522,1.522,0,0,1-.486-.264.415.415,0,0,0-.223-.082.19.19,0,0,0-.159.09.334.334,0,0,0-.067.212.343.343,0,0,0,.125.282,1.709,1.709,0,0,0,.6.325,2.585,2.585,0,0,0,.788.12,1.9,1.9,0,0,0,.778-.154,1.218,1.218,0,0,0,.525-.433,1.114,1.114,0,0,0,.187-.64.932.932,0,0,0-.159-.555,1.175,1.175,0,0,0-.461-.369Z",
    transform: "translate(-155.268 -176.533)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_34",
    transform: "translate(4.002 0.484)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M173.168,176.9a.357.357,0,0,0-.151-.179.407.407,0,0,0-.43,0,.37.37,0,0,0-.151.179l-1.5,3.484a.394.394,0,0,0-.033.154.306.306,0,0,0,.1.228.345.345,0,0,0,.228.095.311.311,0,0,0,.169-.051.332.332,0,0,0,.12-.156l.328-.786h1.917l.328.786a.316.316,0,0,0,.12.156.308.308,0,0,0,.161.051.323.323,0,0,0,.23-.095.3.3,0,0,0,.1-.228.353.353,0,0,0-.033-.154l-1.508-3.484Zm-1.078,2.378.717-1.743.719,1.743Z",
    transform: "translate(-170.9 -176.66)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_35",
    transform: "translate(8.013 0.468)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M190.269,176.7a.36.36,0,0,0-.246-.095.3.3,0,0,0-.289.2l-1.252,3-1.252-3a.337.337,0,0,0-.123-.151.313.313,0,0,0-.172-.051.389.389,0,0,0-.253.095.313.313,0,0,0-.113.241.335.335,0,0,0,.033.141l1.5,3.5a.369.369,0,0,0,.151.174.407.407,0,0,0,.43,0,.384.384,0,0,0,.151-.174l1.508-3.5a.417.417,0,0,0,.033-.146.3.3,0,0,0-.11-.236Z",
    transform: "translate(-186.57 -176.6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_36",
    transform: "translate(13.001 0.501)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M208.376,177.332a.355.355,0,0,0,.246-.079.291.291,0,0,0,.087-.228.284.284,0,0,0-.087-.22.357.357,0,0,0-.246-.077h-1.981a.32.32,0,0,0-.248.095.363.363,0,0,0-.09.266v3.456a.375.375,0,0,0,.09.266.324.324,0,0,0,.248.095h1.981a.366.366,0,0,0,.246-.077.272.272,0,0,0,.087-.22.3.3,0,0,0-.087-.228.359.359,0,0,0-.246-.079h-1.631v-1.221h1.521a.366.366,0,0,0,.246-.077.272.272,0,0,0,.087-.22.286.286,0,0,0-.087-.225.357.357,0,0,0-.246-.077h-1.521v-1.149Z",
    transform: "translate(-206.056 -176.727)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_37",
    transform: "translate(16.789)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M224.684,176.769l-.73.11a2.671,2.671,0,0,1,.044.474,1.718,1.718,0,0,1-.315,1.111,1.2,1.2,0,0,1-1.69.074,1.017,1.017,0,0,1-.074-.074,2.107,2.107,0,0,1,0-2.222,1.086,1.086,0,0,1,.886-.387,1.212,1.212,0,0,1,.538.118l-.312.555.067-.008,1.482-.223-.561-1.528-.369.653a2.1,2.1,0,0,0-.847-.161,2.02,2.02,0,0,0-1.039.256,1.7,1.7,0,0,0-.676.727,2.732,2.732,0,0,0,0,2.222,1.722,1.722,0,0,0,.676.73,2.217,2.217,0,0,0,2.066,0,1.722,1.722,0,0,0,.676-.73,2.455,2.455,0,0,0,.238-1.111,3,3,0,0,0-.059-.586Z",
    transform: "translate(-220.852 -174.77)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    transform: "translate(1625 785)",
    fill: "#fff",
    stroke: "#075e54",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 175,
    height: 198,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 173,
    height: 196,
    rx: 11,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Saveo_Whatsapp_QR",
    transform: "translate(1603.639 1789.639)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M38-968.267v19.733H77.466V-988H38Zm33.828,0v14.095H43.638v-28.19h28.19Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M114-903.543v8.457h16.914V-912H114Z",
    transform: "translate(-64.724 -64.724)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M83.1-985.181v2.819h5.638v5.638H83.1v16.914h5.638v-5.638h11.276v5.638H94.38v28.19H88.742V-942.9H83.1v11.276h5.638v5.638H77.466v-5.638H71.828v5.638h5.638v5.638H71.828v5.638H66.19v-5.638H60.552v5.638H49.276v-5.638h5.638v-5.638H49.276v-5.638H43.638v-5.638H54.914v5.638h5.638v5.638H66.19v-5.638H60.552V-942.9H38v11.276h5.638v5.638H38v11.276H49.276v5.638H43.638v5.638H38v5.638h5.638v-5.638h5.638v-5.638h5.638v16.914H66.19v-5.638H60.552v-5.638H77.466v5.638H71.828v5.638H83.1v5.638H94.38V-869.6h5.638v11.276h5.638v-5.638h11.276v5.638h-5.638v11.276h5.638v-11.276h11.276v-5.638H122.57V-869.6H111.294v-5.638h-5.638v-5.638h5.638v-5.638H122.57v-5.638h5.638V-869.6h5.638v22.552h45.1v-5.638H167.674v-5.638h5.638v-5.638h5.638V-903.43h-5.638v-5.638h5.638v-11.276H167.674v-5.638H156.4v5.638H139.484V-931.62H128.208v5.638H122.57v-11.276h5.638V-942.9H122.57v5.638H105.656V-942.9h5.638v-11.276h-5.638v-5.638h5.638v-5.638h5.638v-11.276h5.638V-988H105.656v5.638h-5.638V-988H94.38v5.638H88.742V-988H83.1Zm33.828,5.638v2.819h-5.638v5.638h-5.638v5.638h-5.638v-11.276h11.276v-5.638h5.638Zm-11.276,31.009v5.638h-5.638v-11.276h5.638Zm0,14.1v2.819h11.276v5.638h-5.638v11.276h5.638v-5.638h22.552v5.638h-5.638v11.276h11.276v-5.638h5.638v5.638h-5.638v5.638H133.846v-5.638h-5.638v5.638H111.294v-5.638h-5.638v11.276h5.638v5.638h-5.638v5.638h-5.638v-5.638H94.38v-5.638H83.1v-5.638h5.638v-5.638H83.1v-5.638H71.828v-5.638H88.742v11.276H94.38v-11.276h11.276v-5.638h-5.638v-5.638h5.638v-5.638h-5.638v-5.638h5.638Zm-56.38,11.276v2.819H43.638v-5.638h5.638Zm112.76,5.638v2.819h11.276v5.638H162.036v5.638h11.276v5.638H156.4v-22.552h5.638ZM66.19-911.887v2.819H60.552v-5.638H66.19Zm84.57,28.19v8.457H133.846v-16.914H150.76Zm11.276-2.819v5.638h11.276V-869.6H162.036v-5.638H156.4v-16.914h5.638Zm11.276-2.819v2.819h-5.638v-5.638h5.638Zm-22.552,28.19v8.457h-5.638V-869.6h5.638Zm11.276,2.819v5.638H156.4v-11.276h5.638Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M608-491.181v2.819h5.638V-494H608Z",
    transform: "translate(-485.43 -420.706)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M532-453.181v2.819h5.638V-456H532Z",
    transform: "translate(-420.706 -453.068)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M418-415.181v2.819h5.638V-418H418Z",
    transform: "translate(-323.62 -485.43)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M456-339.181v2.819h5.638V-342H456Z",
    transform: "translate(-355.982 -550.154)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M722-301.181v2.819h5.638V-304H722Z",
    transform: "translate(-582.516 -582.516)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M722-968.267v19.733h39.466V-988H722Zm33.828,0v14.095h-28.19v-28.19h28.19Z",
    transform: "translate(-582.516 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M798-903.543v8.457h16.914V-912H798Z",
    transform: "translate(-647.24 -64.724)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M613.638-944.362v5.638H608v11.276h5.638v-5.638h5.638V-950h-5.638Z",
    transform: "translate(-485.43 -32.362)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M342-757.181v2.819h5.638V-760H342Z",
    transform: "translate(-258.896 -194.172)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M570-757.181v2.819h5.638V-760H570Z",
    transform: "translate(-453.068 -194.172)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M646-757.181v2.819h5.638V-760H646Z",
    transform: "translate(-517.792 -194.172)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M266-681.181v2.819h5.638V-684H266Z",
    transform: "translate(-194.172 -258.896)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M684-681.181v2.819h5.638V-684H684Z",
    transform: "translate(-550.154 -258.896)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M765.638-681.181v2.819H760v11.276h5.638v-11.276h16.914v5.638h5.638v-5.638h5.638V-684H788.19v5.638h-5.638V-684H765.638Z",
    transform: "translate(-614.878 -258.896)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M38-284.267v19.733H77.466V-304H38Zm33.828,0v14.1H43.638v-28.19h28.19Z",
    transform: "translate(0 -582.516)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M114-219.543v8.457h16.914V-228H114Z",
    transform: "translate(-64.724 -647.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M570-263.181v2.819h5.638V-266H570Z",
    transform: "translate(-453.068 -614.878)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M342-178.724v11.276h5.638v-5.638h5.638v5.638h11.276v-5.638H353.276v-5.638h-5.638V-190H342Z",
    transform: "translate(-258.896 -679.602)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(12 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-whatsapp",
    "data-name": "Icon awesome-whatsapp",
    d: "M17,5.156a9.914,9.914,0,0,0-15.6,11.96L0,22.25l5.254-1.379a9.881,9.881,0,0,0,4.737,1.205h0a10.006,10.006,0,0,0,10-9.911,9.95,9.95,0,0,0-3-7.009ZM10,20.406a8.223,8.223,0,0,1-4.2-1.147l-.3-.179L2.384,19.9l.83-3.04-.2-.312a8.253,8.253,0,1,1,15.308-4.379A8.329,8.329,0,0,1,10,20.406Zm4.518-6.17c-.246-.125-1.464-.723-1.692-.8s-.393-.125-.558.125-.638.8-.786.973-.29.188-.536.063a6.741,6.741,0,0,1-3.371-2.946c-.254-.437.254-.406.728-1.353a.459.459,0,0,0-.022-.433c-.062-.125-.558-1.344-.763-1.839s-.406-.415-.558-.424-.308-.009-.473-.009a.917.917,0,0,0-.661.308,2.783,2.783,0,0,0-.866,2.067,4.851,4.851,0,0,0,1.009,2.563A11.066,11.066,0,0,0,10.2,16.268a4.846,4.846,0,0,0,2.973.621,2.536,2.536,0,0,0,1.67-1.179,2.071,2.071,0,0,0,.143-1.179C14.924,14.42,14.759,14.357,14.513,14.237Z",
    transform: "translate(1643 947.75)",
    fill: "#075e54"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Chat_with_Us",
    "data-name": "Chat with Us",
    transform: "translate(1669 966)",
    fill: "#075e54",
    fontSize: 16,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Chat with Us")))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterWtsapp);
export default __webpack_public_path__ + "static/media/footer_wtsapp.a35686718023fc2f0d4f5130cc9440a3.svg";
export { ForwardRef as ReactComponent };